import type { IFeatureWithDescAndPic } from '@/utils/const/products/interface';
import { WebPNextImage as Image } from '@/components/WebPImage';
import Collapsible from 'react-collapsible';
import styles from './style.module.scss';
import { useState } from 'react';
import classnames from 'classnames';

interface CollapseForMobileProps {
  list: IFeatureWithDescAndPic[];
}

const CollapseForMobile = ({ list }: CollapseForMobileProps) => {
  const [active, setActive] = useState<number>(0);
  return (
    <div className={styles['collapse-wrapper']}>
      {list.map((item, index) => {
        const { title, subTitle, picUrl } = item;
        const isOpened = active === index;
        return (
          <Collapsible
            key={index}
            onTriggerOpening={() => {
              setActive(index);
            }}
            onTriggerClosing={() => {
              setActive(-1);
            }}
            open={isOpened}
            trigger={
              <div className={styles['title']}>
                {title}
                <div
                  className={classnames({
                    [styles['button']]: true,
                    [styles['reverse']]: isOpened,
                  })}
                >
                  <Image
                    src="/img/doc-center/arrowDown.svg"
                    layout="fill"
                    alt="展开"
                  />
                </div>
              </div>
            }
            easing={'ease-in-out'}
            transitionTime={200}
          >
            <main className={styles['pane-container']}>
              <section className={styles['image-section']}>
                <Image src={picUrl} alt={title} layout="fill" />
              </section>
              <section className={styles['text-section']}>{subTitle}</section>
            </main>
          </Collapsible>
        );
      })}
    </div>
  );
};

export default CollapseForMobile;
